<template>
	<div class="page-content">
		<nav class="page-breadcrumb" id="breadcrumb">
			<ol class="breadcrumb">
			<li class="breadcrumb-item">{{breadcrumbA}}</li>
			<li class="breadcrumb-item active" aria-current="page">{{breadcrumbB}}</li>
			</ol>
		</nav>
		<div class="row">
			<div class="col-md-12 grid-margin stretch-card">
			<div class="card">
				<div class="card-body">
				<h6 class="card-title">{{breadcrumbB}}</h6>
				<p class="card-description"> {{descripcion}}</p>






				<table v-if="isLector('Irregular_empresas')==true" width="100%"><td align="right">

					<button style="" class="btn btn-primary mr-2" id="cerrar_estados" data-toggle="modal" data-target="#irregulares_modal">DATOS ACTUALIZADOS - PUEDES CERRAR ESTADOS IRREGULARES</button>
					<button style="display:none;" class="btn btn-danger mr-2" id="actualizar">MODIFICASTE DATOS - ACTUALIZAR Y CIERRA ESTADOS IRREGULARES</button>


				</td></table>




                  <div style="margin-top: -29px;" id="resumen">
                    <table border="1">
                           <tr>
                           	<td colspan="7" style="background-color:#3f5383;color:white;">Estos datos son solo de empresas facturables</td>
                           </tr>
                           <tr style="background-color:#3f5383;color:white;">
                                <td>Empresa</td>
                                <td>Clientes</td>
                                <td>Consumos Salida</td>
                                <td>Consumos Catering</td>
                                <td>Consumos SAP</td>
                                <td>Consumos GRANEL</td>
                                <td>Total</td>
                               
                            </tr>

                           <tr>
                                <td>Food Service America</td>
                                <td id="clientes_ame">0</td>
                                <td id="salida_ame">0</td>
                                <td id="catering_ame">0</td>
                                <td id="sap_ame">0</td>
                                <td id="granel_ame">0</td>
                                <td id="total_ame">0</td>
                            </tr>


                            <tr>
                                <td>Food Service Catering</td>
                                <td id="clientes_cat">0</td>
                                <td id="salida_cat">0</td>
                                <td id="catering_cat">0</td>
                                <td id="sap_cat">0</td>
                                <td id="granel_cat">0</td>
                                <td id="total_cat">0</td>
                            </tr>

                    </table>
                   </div>    

				</div>  

			</div>
			</div>
		</div> 
		<lista-carga v-if="loading"></lista-carga>
		<!-- Template content  -->
		<div class="row" v-else>
			<div class="col-md-12 grid-margin stretch-card">
			<div class="card">
				<div class="card-body">
				
                        <div class="table-responsive">
						<table id="empresas" class="table">
							<thead>
								<tr>
									<th>Nombre</th>
									<th>Al</th>
									<th>Ce</th>
									<th>Vi</th>
									<th>Des</th>
									<th>Mer</th>
									<th>ACV/5 ANT<br><span id="feriado_act"></span></th>
									<th>ACV/5 ACT<br><span id="feriado_ant"></span></th>
									<th>ACV Ayer</th>
									<th>Stat</th>
									<th>Per</th>
									<th>M.O</th>
									<th>AUDITORIA</th>
									<th>Acción</th>
									<th>Razon social</th>
									<th>Cod</th>
									<th>Costos</th>
									<th>Tipo</th>
									<th>Zonal</th>
									<th>Regional</th>
									<th>Seccional</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="operacion in operaciones" v-bind:key="operacion.id">
									<td>
                                        {{operacion.name}}
                                        <small class="d-block text-muted">ID empresa: {{operacion.id}}</small>
                                        <span class="badge badge-success">{{operacion.gama}}</span>
                                    </td>
									<td>{{operacion.almuerzo}}</td>
									<td>{{operacion.cena}}</td>
									<td>{{operacion.vianda}}</td>
									<td>{{operacion.desayuno}}</td>
									<td>{{operacion.merienda}}</td>
									<td :class="operacion.feriados_ant">{{operacion.acvb}}</td>
									<td :class="operacion.feriados_act">{{operacion.acv}}</td>
									<td>{{operacion.ayer}}</td>
									<td>
										<span v-if="operacion.chart=='mayor'"  class="arraw up badge badge-success" style="color:#fff;">↑</span>
										<span v-if="operacion.chart=='menor'" class="arraw down  badge badge-danger" style="color:#fff;">↓</span>
										<span v-if="operacion.chart=='igual'" class="arraw igual badge badge-light" style="color:#000;">↔</span>
									</td>
									<td>{{operacion.personal.toString().replace('.',',')}}</td>
									<td v-if="operacion.manoobra === 'Correcto'"><span class="badge badge-success">{{operacion.manoobra}}</span></td>
									<td v-if="operacion.manoobra === 'Irregular'"><span class="badge badge-danger">{{operacion.manoobra}}</span></td>
									<td v-if="operacion.manoobra === 'Observar'"><span class="badge badge-warning">{{operacion.manoobra}}</span></td>



									<td v-if="operacion.manoobra === 'Irregular'">
										
										<button :class="{
                                  'badge-danger': (operacion.auditada == 'INJUSTIFICADA'),
                                  'badge-success': (operacion.auditada == 'JUSTIFICADA')
                              }" v-if="isEditor('Empresas')==true" type="button" class="btn btn-xs" :id="'operacion-'+operacion.id" :value="operacion.auditada"  @click="aprobar($event, operacion)">{{operacion.auditada}}<br>Actualizacion: {{operacion.auditada_fecha}}</button>


                              	<span :class="{
                                  'badge-danger': (operacion.auditada == 'INJUSTIFICADA'),
                                  'badge-success': (operacion.auditada == 'JUSTIFICADA')
                              }" v-if="isLector('VerEmpresasAuditadas')==true">{{operacion.auditada}}<br>Actualizacion: {{operacion.auditada_fecha}}</span>
									
									</td>

									<td v-else> - </td>


									<td>
										
										<button v-if="isEditor('Empresas')==true" type="button" class="btn btn-primary btn-xs" @click="administrarOperacionId(operacion.id, operacion.name, 'personal')">Personal</button>
										<button v-else type="button" class="btn btn-secondary btn-xs" disabled>Personal</button>
										<button v-if="isEditor('Empresas')==true" class="btn btn-warning btn-xs ml-2" @click="administrarOperacionId(operacion.id, operacion.name, 'zonal')">Zonal</button>
										<button v-else class="btn btn-secondary btn-xs ml-2" disabled>Zonal</button>
											<button v-if="isEditor('Empresas')==true" class="btn btn-info btn-xs ml-2" @click="administrarOperacionId(operacion.id, operacion.name, 'regional')">Regional</button>
										<button v-else class="btn btn-secondary btn-xs ml-2" disabled>Regional</button>
										<button type="button" class="btn btn-secondary btn-xs ml-2" @click="observarOperacionId(operacion.id, operacion.name)">
											Observacion
											<div class="observacion-existente" v-if="operacion.observacion">✓</div>
										</button>
									</td>
									<td v-if="operacion.razonsocial=='Food Service America'"><span class="badge badge-success">{{operacion.razonsocial}}</span></td>
									<td v-else><span class="badge badge-info">{{operacion.razonsocial}}</span></td>
									<td>{{operacion.centroapropiacion_id}}</td>
									<td>{{operacion.codigo_costos}}</td>
									<td>{{operacion.tipo_empresa}}</td>
									<td>{{operacion.zonal}}</td>
									<td>{{operacion.regional}}</td>
									<td>{{operacion.seccional}}</td>

								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			</div>
		</div>
		<!-- <div class="row">
			<div>
				<Select2 v-model="myValue" :options="empleados" :settings="{ settingOption: value, settingOption: value, width:'100%', theme: 'classic' }" @change="myChangeEvent($event)" @select="mySelectEvent($event)" />
				<h4>Value: {{ myValue }}</h4>
			</div>
		</div> -->



<!-- Modal -->
<div class="modal fade bd-example-modal-lg" id="irregulares_modal" tabindex="-1" aria-labelledby="irregulares_modalLabel" aria-hidden="true">
   <div class="modal-dialog modal-lg  modal-dialog-scrollable">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title" id="irregulares_modalLabel"></h5>
        
      </div>
      <div class="modal-body " >
      	<table width="100%">

       <td><table id="contenido_irregulares" border="1" cellpadding="3" width="90%"></table></td>
       <td><table id="contenido_injustificadas" border="1" cellpadding="3" width="90%"></table></td>

    	 </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">CERRAR</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" id="guardar_estados">GUARDAR Y ENVIAR A APROBACIÓN</button>
      </div>
    </div>
  </div>
</div>



        <modal-administrar
            v-if="modalAdministrar" 
            :empresa="modalOperacionId"
			:nombreEmpresa="modalOperacionNombre"
            @cerrar-modal-asignar="refrescarEmpresas($event)"
			v-on:keyup.enter="modalAdministrar=false"
        >
        </modal-administrar>

		<modal-observar
			v-if="modalObservar" 
            :idEmpresa="modalOperacionId"
			:nombreEmpresa="modalOperacionNombre"
            @cerrar-modal-observar="refrescarEmpresas($event)"
			v-on:keyup.enter="modalObservar=false"
		></modal-observar>

		<modal-zonal
		v-if="modalZonal"
		:empresa="modalOperacionId"
		:nombreEmpresa="modalOperacionNombre"
		@cerrar-modal-zonal="refrescarEmpresas($event)"
		></modal-zonal>

		<modal-regional
		v-if="modalRegional"
		:empresa="modalOperacionId"
		:nombreEmpresa="modalOperacionNombre"
		@cerrar-modal-regional="refrescarEmpresas($event)"
		></modal-regional>
	</div>
</template>
<script>
import axios from 'axios';
import $ from 'jquery';
import ModalAdministrar from './ModalAdministrar.vue';
import ModalObservar from './ModalObservar.vue';
import ListaCarga from "../ListaCarga";
import ModalZonal from './ModalZonal.vue';
import ModalRegional from './ModalRegional.vue';
import firebase from "firebase/app";
import "firebase/database";
require('datatables.net');
require('datatables.net-buttons/js/buttons.colVis.js')();
require('datatables.net-buttons/js/buttons.html5.js')();
require('datatables.net-buttons/js/buttons.flash.js')();
require('datatables.net-buttons/js/buttons.print.js')();
import Swal from "sweetalert2";
import router from '../../router'

const userPermission = JSON.parse(sessionStorage.getItem('userPermisos')) || [];

// Los IDs son identificadores, NO números: "000544", "00544" y "544" son distintos.
// No utilizar parseInt(), Number(), == ni padStart() para emparejar empresas.
function idEmpresaExacto(id) {
    return (typeof id === 'string' || typeof id === 'number') ? String(id).trim() : '';
}

function mismaEmpresa(idA, idB) {
    const a = idEmpresaExacto(idA);
    return a !== '' && a === idEmpresaExacto(idB);
}

// Firebase almacena distribucion, zonal y regional bajo la clave LITERAL de empresa.
// Leer con esa clave evita asignar el personal de 000544 a 544.
function registroPorEmpresa(registros, id) {
    const clave = idEmpresaExacto(id);
    if (!clave || !registros || typeof registros !== 'object') return null;
    return Object.prototype.hasOwnProperty.call(registros, clave) ? registros[clave] : null;
}

// Conservar ambas fuentes y sus claves, sin Object.assign(): dos servicios
// con una clave/nombre igual no deben sobrescribirse antes de comparar su ID.
function entradasDeServicios(respuesta) {
    const grupos = Array.isArray(respuesta) ? respuesta : [];
    return grupos.reduce((acumulado, grupo) => {
        ['CAT', 'SAL'].forEach(tipo => {
            const registros = grupo && grupo[tipo];
            if (registros && typeof registros === 'object') {
                acumulado.push(...Object.entries(registros));
            }
        });
        return acumulado;
    }, []);
}


export default {
    components: { 
        ModalAdministrar, 
        ListaCarga ,
		ModalObservar,
        ModalZonal,
         ModalRegional
    },    
	name: 'Empresas',
   
    data() {
        return {
			breadcrumbA: 'Inicio',
            breadcrumbB: 'Empresas',
            descripcion: 'En este modulo usted podra visualizar y administrar personal en todas nuestras operaciones',
			loading: true,
            operaciones: [],
            alertasIdentidad: [],
			modalOperacionId: null,
			modalOperacionNombre: null,
			modalAdministrar: false,
			modalObservar: false,
			modalZonal: false,
			modalRegional: false,
			modalAprobar: false,
        }
    },

    methods: {
    	isEditor(modulo){
          if (userPermission.find( record => record.ModulosAccess === modulo)) {
            var status =  userPermission.find( record => record.ModulosAccess === modulo).Editor;
            // console.log(modulo+' : '+status)
            return status;
          }else{
            console.log(modulo+' : '+false)
            return false;
          }
      	}, isLector(modulo){
      
          if (userPermission.find( record => record.ModulosAccess === modulo)) {
            var status =  userPermission.find( record => record.ModulosAccess === modulo).Lector;
            // console.log(modulo+' : '+status)
            return status;
          }else{
            // console.log(modulo+' : '+false)
            return false;
          }
      },
		administrarOperacionId(id, nombre, modal){
			this.modalOperacionId = idEmpresaExacto(id);
			this.modalOperacionNombre = nombre;
			setTimeout(() => {
				if (modal == 'personal') {
					this.modalAdministrar = true;
				} else if (modal=='zonal') {
					this.modalZonal = true;
				}else if (modal=='regional') {
					this.modalRegional = true;
				}
			}, 200);
		},
		aprobar(event, caso){
			var estado = "";
			if (event.target.value=="JUSTIFICADA") {
				estado = "INJUSTIFICADA";
			}

			if (event.target.value=="INJUSTIFICADA") {
				estado = "JUSTIFICADA";
			}


	      var hoy = new Date();

				var mesh = hoy.getMonth() + 1;
				var meshoy = mesh < 10 ? "0" + mesh : mesh;
				var diahoy= hoy.getDate();
				diahoy = diahoy < 10 ? "0" + diahoy : diahoy;
				var hoy_dato =  diahoy+ "-" + meshoy + "-" + hoy.getFullYear();

			console.log(event.target)
        firebase.database().ref('auditadas_data/' + idEmpresaExacto(caso.id)).update({
            status: estado,
            fecha:hoy_dato
        })
        .then(()=>{
            
           	 caso.auditada = estado;
           	 caso.auditada_fecha = hoy_dato;

        		if (estado=="JUSTIFICADA") {
        			  $("#operacion-"+event.target.id).removeClass("badge-danger");
        				$("#operacion-"+event.target.id).addClass("badge-success");
        				$("#operacion-"+event.target.id).html("JUSTIFICADA<br>Actualizacion: "+hoy_dato);
        				console.log(estado)
        		}

        		if (estado=="INJUSTIFICADA") {
        			  $("#operacion-"+event.target.id).removeClass("badge-success");
        				$("#operacion-"+event.target.id).addClass("badge-danger");
        				$("#operacion-"+event.target.id).html("INJUSTIFICADA");
        				console.log(estado)
        		}

        		 $("#cerrar_estados").hide();
           	 $("#actualizar").show();
        		

        })
        .catch(e => {




        });


    },
		observarOperacionId(id, nombre){
			this.modalOperacionId = idEmpresaExacto(id);
			this.modalOperacionNombre = nombre;
			setTimeout(() => {
				this.modalObservar = true;
			}, 200);
		},
		async obtenerInformacionEmpresas(){
			
			this.loading = true;
            this.alertasIdentidad = [];
            const alertasIdentidad = this.alertasIdentidad;

			// ------------------------------
			// FECHAS CORREGIDAS
			// Regla: los consumos semanales siempre van de LUNES a VIERNES.
			// No usar new Date("YYYY-MM-DD") porque Javascript lo interpreta en UTC
			// y en Argentina puede correr el día a la fecha anterior.
			// ------------------------------
			const padFecha = (numero) => numero < 10 ? "0" + numero : numero.toString();

			const fechaLocal = (fecha) => {
				return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), 12, 0, 0);
			};

			const sumarDias = (fecha, dias) => {
				return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + dias, 12, 0, 0);
			};

			const formatearFecha = (fecha) => {
				return fecha.getFullYear() + "-" + padFecha(fecha.getMonth() + 1) + "-" + padFecha(fecha.getDate());
			};

			const lunesDeSemana = (fechaReferencia) => {
				const fecha = fechaLocal(fechaReferencia);
				const diaSemana = fecha.getDay(); // domingo=0, lunes=1, ..., sábado=6
				const diferenciaAlLunes = diaSemana === 0 ? -6 : 1 - diaSemana;
				return sumarDias(fecha, diferenciaAlLunes);
			};

			const lunesActual = lunesDeSemana(new Date());
			const lunesSemanaPasada = sumarDias(lunesActual, -7);
			const viernesSemanaPasada = sumarDias(lunesSemanaPasada, 4);
			const lunesSemanaAnterior = sumarDias(lunesSemanaPasada, -7);
			const viernesSemanaAnterior = sumarDias(lunesSemanaAnterior, 4);

			var dia1 = formatearFecha(lunesSemanaPasada);
			var dia2 = formatearFecha(viernesSemanaPasada);
			var dia1b = formatearFecha(lunesSemanaAnterior);
			var dia2b = formatearFecha(viernesSemanaAnterior);

			var ayer = formatearFecha(sumarDias(new Date(), -1));
			var hoy_dato = formatearFecha(new Date());

			console.log("Semana pasada:", dia1, dia2);
			console.log("Semana anterior:", dia1b, dia2b);

		const axiosrequest1 = axios.get('https://consumos.foodservice.com.ar/api/empresas');
		const axiosrequest2 = axios.get('https://aplicativos.firebaseio.com/zonal.json?print=pretty');
		const axiosrequest4 = axios.get('https://aplicativos.firebaseio.com/distribucion.json?print=pretty');
		const axiosrequest5 = axios.get('https://aplicativos.firebaseio.com/observacion.json?print=pretty');
		const axiosrequest6 = axios.get('https://consumos.foodservice.com.ar/api/totalEmpresas/'+dia1+'/'+dia2);
		const axiosrequest7 = axios.get('https://consumos.foodservice.com.ar/api/totalEmpresas/'+dia1b+'/'+dia2b);
		const axiosrequest8 = axios.get('https://consumos.foodservice.com.ar/api/totalEmpresas/'+ayer+'/'+ayer);
		const axiosPersonal = axios.get('https://auth.foodservice.com.ar/?type=personal&access_token=1234567');
		const feriados_data = axios.get('https://aplicativos.firebaseio.com/feriados_data.json?print=pretty');
		const auditadas_dato = axios.get('https://aplicativos.firebaseio.com/auditadas_data.json?print=pretty');
		const regional_dato = axios.get('https://aplicativos.firebaseio.com/regional.json?print=pretty');

		
        


		await axios.all([axiosrequest1, axiosrequest2, axiosrequest4, axiosrequest5,axiosrequest6,axiosrequest7,axiosPersonal,axiosrequest8,feriados_data,auditadas_dato,regional_dato]).then(axios.spread((operaciones, zonales, distribucion, observaciones,servicios,serviciosb,personal,serviciosc,feriados,auditadas_data,regional_data) => {	





					// Crear un array para almacenar los días de lunes a viernes
					var diasSemanaPasada = [];

					// Recorrer los días de la semana pasada y agregar los días de lunes a viernes al array
					for (var i = 0; i < 5; i++) {
						var dia = sumarDias(lunesSemanaPasada, i);
						var dia_ok = formatearFecha(dia);
						diasSemanaPasada.push(dia_ok);
					}





						// Crear un array para almacenar los días de lunes a viernes
					var diasSemanaPasadaAnterior = [];

					// Recorrer los días de la semana pasada y agregar los días de lunes a viernes al array
					for (var i = 0; i < 5; i++) {
						var dia_b = sumarDias(lunesSemanaAnterior, i);
						var dia_ok_b = formatearFecha(dia_b);
						diasSemanaPasadaAnterior.push(dia_ok_b);
					}



						// Imprimir los días de la semana pasada
						console.log(diasSemanaPasada);

						// Imprimir los días de la semana pasada anterior
						console.log(diasSemanaPasadaAnterior);


				

					var dias_feriados=[];
					

					for (var i = 0; i < feriados.data.length; i++) {
						if (feriados.data[i]!=null) {
							
								        var dia_f = feriados.data[i].dia < 10 ? '0' + feriados.data[i].dia : feriados.data[i].dia.toString();
												var mes_f = feriados.data[i].mes < 10 ? '0' + feriados.data[i].mes : feriados.data[i].mes.toString();
												var anio_f =feriados.data[i].anio;

												dias_feriados.push(anio_f+"-"+mes_f+"-"+dia_f);
						}
						
					}


					


					const numerosComunes = diasSemanaPasada.filter(numero => dias_feriados.includes(numero));
					const cantidadNumerosComunes = numerosComunes.length;


					const numerosComunes_b = diasSemanaPasadaAnterior.filter(numero => dias_feriados.includes(numero));
					const cantidadNumerosComunes_b = numerosComunes_b.length;


					console.log(cantidadNumerosComunes)
					console.log(cantidadNumerosComunes_b)

					var divisor = 5-cantidadNumerosComunes;


					var estiloFeriado_act=5-cantidadNumerosComunes;
					var estiloFeriado_ant=5-cantidadNumerosComunes_b;



				 /**
				 * Se recorre el personal y comprueba si el cat_codigo es uno de part time
				 * Si lo es, en un array guarda true a partir de la clave legajo.
				 * Por ejemplo ["4658"] = true. Así se obtiene una complejidad O(n)
				 */
				var empleadosPartTime = [];
				$.each(personal.data,function(clave,item){ 
					
					let cat = item.cpf_codigo;
				
					// Busqueda de legajos con las categorias: 65,77, 78, 79, 80, 81, 82
					if (cat == "605" || cat == "616" || cat == "608" || cat == "562") {
	
						empleadosPartTime[item.leg_numero.toString()] = true
					}
				})
				
				
				var services = [];
				var servicesb = [];
				var servicesc = [];

				let jsons = entradasDeServicios(servicios.data)

				console.log(jsons)
			
				$.each(jsons,function(_, [clave, valor]){				
					if(valor.Servicios.VIANDAS!=undefined){
						services.push({
							"cantidad": valor.Servicios.VIANDAS,
							"cantidad_categoria": valor.Servicios.VIANDAS,
							"categoria": "VIANDAS",
							"catering_id": 0,
							"empresa": clave,
							"empresa_id": valor.empresa_id,
							"nombre_servicio": "VIANDAS",
							"servicio_id": 0
						});
					}

					if(valor.Servicios.ALMUERZO!=undefined){
						services.push({
							"cantidad": valor.Servicios.ALMUERZO,
							"cantidad_categoria": valor.Servicios.ALMUERZO,
							"categoria": "ALMUERZO",
							"catering_id": 0,
							"empresa": clave,
							"empresa_id": valor.empresa_id,
							"nombre_servicio": "ALMUERZO",
							"servicio_id": 0
						});
					}

					if(valor.Servicios.CENA!=undefined){
						services.push({
							"cantidad": valor.Servicios.CENA,
							"cantidad_categoria": valor.Servicios.CENA,
							"categoria": "CENA",
							"catering_id": 0,
							"empresa": clave,
							"empresa_id": valor.empresa_id,
							"nombre_servicio": "CENA",
							"servicio_id": 0
						});
					}

					if(valor.Servicios.DESAYUNOS!=undefined){

						services.push({
							"cantidad": valor.Servicios.DESAYUNOS,
							"cantidad_categoria": valor.Servicios.DESAYUNOS,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": clave,
							"empresa_id": valor.empresa_id,
							"nombre_servicio": "DESAYUNOS",
							"servicio_id": 0
						});

					}


					if(valor.Servicios.DESAYUNOS!=undefined){

						services.push({
							"cantidad": valor.Servicios.DESAYUNOS,
							"cantidad_categoria": valor.Servicios.DESAYUNOS,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": clave,
							"empresa_id": valor.empresa_id,
							"nombre_servicio": "DESAYUNOS",
							"servicio_id": 0
						});

					}


					if(valor.Servicios.MERIENDA!=undefined){

						services.push({
							"cantidad": valor.Servicios.MERIENDA,
							"cantidad_categoria": valor.Servicios.MERIENDA,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": clave,
							"empresa_id": valor.empresa_id,
							"nombre_servicio": "MERIENDA",
							"servicio_id": 0
						});

					}
					


				});



	/* ------ 2 SEMANAS ATRAS  ------- */


	let jsonsb = entradasDeServicios(serviciosb.data)

				// console.log(jsons)
			
				$.each(jsonsb,function(_, [claveb, valorb]){				
					

					if(valorb.Servicios.VIANDAS!=undefined){
						servicesb.push({
							"cantidad": valorb.Servicios.VIANDAS,
							"cantidad_categoria": valorb.Servicios.VIANDAS,
							"categoria": "VIANDAS",
							"catering_id": 0,
							"empresa": claveb,
							"empresa_id": valorb.empresa_id,
							"nombre_servicio": "VIANDAS",
							"servicio_id": 0
						});
					}

					if(valorb.Servicios.ALMUERZO!=undefined){
						servicesb.push({
							"cantidad": valorb.Servicios.ALMUERZO,
							"cantidad_categoria": valorb.Servicios.ALMUERZO,
							"categoria": "ALMUERZO",
							"catering_id": 0,
							"empresa": claveb,
							"empresa_id": valorb.empresa_id,
							"nombre_servicio": "ALMUERZO",
							"servicio_id": 0
						});
					}

					if(valorb.Servicios.CENA!=undefined){
						servicesb.push({
							"cantidad": valorb.Servicios.CENA,
							"cantidad_categoria": valorb.Servicios.CENA,
							"categoria": "CENA",
							"catering_id": 0,
							"empresa": claveb,
							"empresa_id": valorb.empresa_id,
							"nombre_servicio": "CENA",
							"servicio_id": 0
						});
					}

					if(valorb.Servicios.DESAYUNOS!=undefined){

						servicesb.push({
							"cantidad": valorb.Servicios.DESAYUNOS,
							"cantidad_categoria": valorb.Servicios.DESAYUNOS,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": claveb,
							"empresa_id": valorb.empresa_id,
							"nombre_servicio": "DESAYUNOS",
							"servicio_id": 0
						});

					}


					if(valorb.Servicios.DESAYUNOS!=undefined){

						servicesb.push({
							"cantidad": valorb.Servicios.DESAYUNOS,
							"cantidad_categoria": valorb.Servicios.DESAYUNOS,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": claveb,
							"empresa_id": valorb.empresa_id,
							"nombre_servicio": "DESAYUNOS",
							"servicio_id": 0
						});

					}


					if(valorb.Servicios.MERIENDA!=undefined){

						servicesb.push({
							"cantidad": valorb.Servicios.MERIENDA,
							"cantidad_categoria": valorb.Servicios.MERIENDA,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": claveb,
							"empresa_id": valorb.empresa_id,
							"nombre_servicio": "MERIENDA",
							"servicio_id": 0
						});

					}
					


				});

			
		/* ------ CIERRA 2 SEMANAS ATRAS  ------- */		



/* ------ AYER   ------- */


	let jsonsc = entradasDeServicios(serviciosc.data)

				
			
				$.each(jsonsc,function(_, [clavec, valorc]){				
					

					if(valorc.Servicios.VIANDAS!=undefined){
						servicesc.push({
							"cantidad": valorc.Servicios.VIANDAS,
							"cantidad_categoria": valorc.Servicios.VIANDAS,
							"categoria": "VIANDAS",
							"catering_id": 0,
							"empresa": clavec,
							"empresa_id": valorc.empresa_id,
							"nombre_servicio": "VIANDAS",
							"servicio_id": 0
						});
					}



					if(valorc.Servicios.ALMUERZO!=undefined){
						servicesc.push({
							"cantidad": valorc.Servicios.ALMUERZO,
							"cantidad_categoria": valorc.Servicios.ALMUERZO,
							"categoria": "ALMUERZO",
							"catering_id": 0,
							"empresa": clavec,
							"empresa_id": valorc.empresa_id,
							"nombre_servicio": "ALMUERZO",
							"servicio_id": 0
						});
					}

					if(valorc.Servicios.CENA!=undefined){
						servicesc.push({
							"cantidad": valorc.Servicios.CENA,
							"cantidad_categoria": valorc.Servicios.CENA,
							"categoria": "CENA",
							"catering_id": 0,
							"empresa": clavec,
							"empresa_id": valorc.empresa_id,
							"nombre_servicio": "CENA",
							"servicio_id": 0
						});
					}

					if(valorc.Servicios.DESAYUNOS!=undefined){

						servicesc.push({
							"cantidad": valorc.Servicios.DESAYUNOS,
							"cantidad_categoria": valorc.Servicios.DESAYUNOS,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": clavec,
							"empresa_id": valorc.empresa_id,
							"nombre_servicio": "DESAYUNOS",
							"servicio_id": 0
						});

					}


					if(valorc.Servicios.DESAYUNOS!=undefined){

						servicesc.push({
							"cantidad": valorc.Servicios.DESAYUNOS,
							"cantidad_categoria": valorc.Servicios.DESAYUNOS,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": clavec,
							"empresa_id": valorc.empresa_id,
							"nombre_servicio": "DESAYUNOS",
							"servicio_id": 0
						});

					}


					if(valorc.Servicios.MERIENDA!=undefined){

						servicesc.push({
							"cantidad": valorc.Servicios.MERIENDA,
							"cantidad_categoria": valorc.Servicios.MERIENDA,
							"categoria": "DESAYUNOS",
							"catering_id": 0,
							"empresa": clavec,
							"empresa_id": valorc.empresa_id,
							"nombre_servicio": "MERIENDA",
							"servicio_id": 0
						});

					}
					


				});

			
		/* ------ CIERRA AYER  ------- */		






			var lista = [];
			var irregulares = [];
			var justificadas = [];

			var zonal = "-";
			var regional = "-";
			var almuerzo = 0;
			var cena = 0;
			var vianda = 0;
			var desayuno = 0;
			var merienda = 0;
			var personal = 0;
			var num = 0;
			var status = "-";
			var observacion = false;
			var legales = false;
			

			var almuerzob = 0;
			var cenab = 0;
			var viandab = 0;



			var almuerzo_a = 0;
			var cena_a = 0;
			var vianda_a = 0;
			var desayuno_a = 0;
			var merienda_a = 0;

			var almuerzo_ab = 0;
			var cena_ab = 0;
			var vianda_ab = 0;


			var almuerzoc = 0;
			var cenac = 0;
			var viandac = 0;
			var almuerzo_ac = 0;
			var cena_ac = 0;
			var vianda_ac = 0;
			var gama = false;
		// console.log(operaciones.data);
		$.each(operaciones.data, function(clave, valor) {
            if (!valor) return;

            // Cuando la API devuelve un objeto indexado por el ID original,
            // esa clave puede preservar ceros que se perdieron en el campo id numérico.
            const claveOriginal = (!Array.isArray(operaciones.data) && /^\d+$/.test(String(clave)) &&
                typeof valor.id === 'number' && Number(clave) === valor.id) ? String(clave) : null;
            const fuenteId = valor.id_empresa != null ? valor.id_empresa : (claveOriginal || valor.id);
            const idOperacion = idEmpresaExacto(fuenteId);
            if (!idOperacion) {
                console.error('[Empresas] Operación sin ID: se omite para no mezclar distribuciones.', valor);
                return;
            }
            if (typeof fuenteId === 'number') {
                const todasClaves = [distribucion.data, zonales.data, regional_data.data]
                    .filter(obj => obj && typeof obj === 'object')
                    .reduce((acum, obj) => acum.concat(Object.keys(obj)), []);
                const posibles = Array.from(new Set(todasClaves.filter(k =>
                    /^\d+$/.test(k) && Number(k) === fuenteId)));
                const otrasClaves = posibles.filter(k => k !== idOperacion);
                if (otrasClaves.length) {
                    const aviso = 'Empresa ' + (valor.name || idOperacion) + ': la API envió el ID ' +
                        fuenteId + ' como número, pero existen claves como ' + otrasClaves.join(', ') +
                        '. No se puede identificar su distribución sin el ID original en texto.';
                    console.error('[Empresas]', aviso);
                    alertasIdentidad.push(aviso);
                    return; // No atribuir personal o consumos a una empresa por suposición.
                }
                console.warn('[Empresas] La API de empresas devuelve un ID numérico (' + fuenteId +
                    '). Si originalmente tenía ceros a la izquierda, ya se perdieron. ' +
                    'Es necesario que la API devuelva id_empresa como string.');
            }

			

			var acv = 0;
			var acvb = 0;
			var acvc = 0;
            // Reiniciar estado antes de cada empresa, sin heredar la anterior.
            zonal = '-';
            regional = '-';
            personal = 0;
            status = '-';
            num = 0;
            almuerzo_a = cena_a = vianda_a = desayuno_a = merienda_a = 0;
            almuerzo_ab = cena_ab = vianda_ab = 0;
            almuerzo_ac = cena_ac = vianda_ac = 0;

            // Comparaciones por CLAVE EXACTA; nunca comparar como números.
            const datoZonal = registroPorEmpresa(zonales.data, idOperacion);
            zonal = datoZonal && datoZonal.nombre ? datoZonal.nombre : '-';

            const datoRegional = registroPorEmpresa(regional_data.data, idOperacion);
            regional = datoRegional && datoRegional.nombre ? datoRegional.nombre : '-';

            // Distribución aislada por empresa. "000544" no busca ni acumula "544".
            const distribucionEmpresa = registroPorEmpresa(distribucion.data, idOperacion);
            if (distribucionEmpresa && typeof distribucionEmpresa === 'object') {
                let cantPersonal = 0;
                Object.keys(distribucionEmpresa).forEach((claveEmpleado) => {
                    const asignacion = distribucionEmpresa[claveEmpleado];
                    if (!asignacion || asignacion.legajo == null) return;
                    const legajo = String(asignacion.legajo).trim();
                    cantPersonal += Object.prototype.hasOwnProperty.call(empleadosPartTime, legajo) ? 0.5 : 1;
                });
                personal = cantPersonal;
            } else {
                personal = 0;
            }

			var consumo = services.filter((el) => mismaEmpresa(el.empresa_id, idOperacion));
			var consumob = servicesb.filter((el) => mismaEmpresa(el.empresa_id, idOperacion));
			var consumoc = servicesc.filter((el) => mismaEmpresa(el.empresa_id, idOperacion));


			 gama = false;


			/* --- CONSUMOS --- */







			

			// console.log(consumo);
			if (valor.estado=='ACTIVA') {

				/* --- CONSUMOS --- */
				var result_almuerzo = consumo.filter(function(c) {
					return c.categoria == "ALMUERZO"
				});
				if (result_almuerzo.length != 0) {
					almuerzo = result_almuerzo[0].cantidad_categoria;
					almuerzo_a = Math.round(result_almuerzo[0].cantidad_categoria/divisor);
				}else{
					almuerzo = 0;
					almuerzo_a = 0;
				}

				var result_cena = consumo.filter(function(c) {
					return c.categoria == "CENA"
				});
				if (result_cena.length != 0) {
					cena = result_cena[0].cantidad_categoria;
					cena_a = Math.round(result_cena[0].cantidad_categoria/divisor);
				}else{
					cena = 0;
					cena_a = 0;
				}

				var result_viandas = consumo.filter(function(c) {
					return c.categoria == "VIANDAS"
				});
				if (result_viandas.length != 0) {
					vianda = result_viandas[0].cantidad_categoria;
					vianda_a = Math.round(result_viandas[0].cantidad_categoria/divisor);
				}else{
					vianda = 0;
					vianda_a = 0;
				}


				/*----  2 SEMANAS ANTERIOR ----- */

				/* --- CONSUMOS --- */
				var result_almuerzob = consumob.filter(function(c) {
					return c.categoria == "ALMUERZO"
				});
				if (result_almuerzob.length != 0) {
					almuerzob = result_almuerzob[0].cantidad_categoria;
					almuerzo_ab= Math.round(result_almuerzob[0].cantidad_categoria/5);
				}else{
					almuerzob = 0;
					almuerzo_ab = 0;
				}

				var result_cenab = consumob.filter(function(c) {
					return c.categoria == "CENA"
				});
				if (result_cenab.length != 0) {
					cenab = result_cenab[0].cantidad_categoria;
					cena_ab = Math.round(result_cenab[0].cantidad_categoria/5);
				}else{
					cenab = 0;
					cena_ab = 0;
				}

				var result_viandasb = consumob.filter(function(c) {
					return c.categoria == "VIANDAS"
				});
				if (result_viandasb.length != 0) {
					viandab = result_viandasb[0].cantidad_categoria;
					vianda_ab = Math.round(result_viandasb[0].cantidad_categoria/5);
				}else{
					viandab = 0;
					vianda_ab = 0;
				}

				/*----  2 SEMANAS ANTERIOR ----- */



					/*----  AYER ----- */

				/* --- CONSUMOS --- */
				var result_almuerzoc = consumoc.filter(function(c) {
					return c.categoria == "ALMUERZO"
				});
				if (result_almuerzoc.length != 0) {
					almuerzoc = result_almuerzoc[0].cantidad_categoria;
					almuerzo_ac= Math.round(result_almuerzoc[0].cantidad_categoria);
				}else{
					almuerzoc = 0;
					almuerzo_ac = 0;
				}

				var result_cenac = consumoc.filter(function(c) {
					return c.categoria == "CENA"
				});
				if (result_cenac.length != 0) {
					cenac = result_cenac[0].cantidad_categoria;
					cena_ac = Math.round(result_cenac[0].cantidad_categoria);
				}else{
					cenac = 0;
					cena_ac = 0;
				}

				var result_viandasc = consumoc.filter(function(c) {
					return c.categoria == "VIANDAS"
				});
				if (result_viandasc.length != 0) {
					viandac = result_viandasc[0].cantidad_categoria;
					vianda_ac = Math.round(result_viandasc[0].cantidad_categoria);
				}else{
					viandac = 0;
					vianda_ac = 0;
				}

				/*----  2 AYER ----- */


				var result_desayuno = consumo.filter(function(c) {
					return c.categoria == "DESAYUNOS"
				});
				if (result_desayuno.length != 0) {
					desayuno = result_desayuno[0].cantidad_categoria;
					desayuno_a = Math.round(result_desayuno[0].cantidad_categoria/5);
				}else{
					desayuno = 0;
					desayuno_a = 0;
				}


				
				var result_merienda = consumo.filter(function(c) {
					return c.categoria == "MERIENDA"
				});
				if (result_merienda.length != 0) {
					merienda = result_merienda[0].cantidad_categoria;
					merienda_a = Math.round(result_merienda[0].cantidad_categoria/5);
				}else{
					merienda = 0;
					merienda_a = 0;
				}







				acv = parseInt(almuerzo_a) + parseInt(cena_a) + parseInt(vianda_a);
				acvb = parseInt(almuerzo_ab) + parseInt(cena_ab) + parseInt(vianda_ab);
				acvc = parseInt(almuerzo_ac) + parseInt(cena_ac) + parseInt(vianda_ac);
				/* --- CONSUMOS --- */
				acv = Math.round(acv);
				acvb = Math.round(acvb);
				acvc = Math.round(acvc);
				/* --- CONSUMOS --- */
				

				/* --  MANO DE OBRA  --*/
				

				if(valor.tipo_empresa=="COMEDOR"){



						if (acv < 300) {
							num = Math.round(acv / 40);
						}

						if (acv > 300) {
							num = Math.round(acv / 50);
						}

						




				}

				if(valor.tipo_empresa=="CATERING"){

						num = Math.round(acv / 70);
	if(valor.tipo_etiquetado_id==3){

						num = Math.round(acv / 60);

						emp_tipo = "GRANEL";
					
					}


						

				}




				var emp_tipo = valor.tipo_empresa;


				

					if(valor.armado_tipo_empresa_id=="2"){

						num = Math.round(acv / 0);

						emp_tipo = "SAP";

						if (personal == 0) {
							status = "Correcto";
						}else{
							status = "Irregular";
						}
					
					}




				if(valor.cuarta_gama=="S"){

						
						 gama = true;




							if(valor.tipo_empresa=="COMEDOR"){



									if (acv < 300) {
										num = Math.round(acv / 44);
									}

									if (acv > 300) {
										num = Math.round(acv / 55);
									}

									




							}

							if(valor.tipo_empresa=="CATERING"){

									num = Math.round(acv / 77);
if(valor.tipo_etiquetado_id==3){

							num = Math.round(acv / 66);

							emp_tipo = "GRANEL";
						
						}


									

							}



						

						


						

				}



				if (personal > num) {
					status = "Irregular";
				}

				if (personal < num) {

					status = "Correcto";
				}

				if (personal == num) {
					status = "Observar";
				}



				/* --  MANO DE OBRA  --*/


				var comentario = "-";
				var comentario_status = (registroPorEmpresa(observaciones.data, idOperacion) != undefined) ? true : false;
				if (comentario_status) {
					comentario = registroPorEmpresa(observaciones.data, idOperacion).observacion
				}

				
				

				// Observacion
				observacion = (registroPorEmpresa(observaciones.data, idOperacion) != undefined) ? true : false;

				var chart = "igual";
				if (acv>acvb) {
					chart = "mayor"
				}

				if (acv<acvb) {
					chart = "menor"
				}



						

var auditadas="INJUSTIFICADA";
var auditadas_fecha="-";

if (auditadas_data.data!=null) {
	if (registroPorEmpresa(auditadas_data.data, idOperacion)!=null) {
		  
		  if (registroPorEmpresa(auditadas_data.data, idOperacion).status=="INJUSTIFICADA") {
		  	auditadas="INJUSTIFICADA";
		  }

		  if (registroPorEmpresa(auditadas_data.data, idOperacion).status=="JUSTIFICADA") {
		  	auditadas="JUSTIFICADA";
		  	auditadas_fecha=registroPorEmpresa(auditadas_data.data, idOperacion).fecha;
		  }
	}
}


var estilo_act = "noferiado";
var estilo_ant = "noferiado";
if ((5-estiloFeriado_act)>0) {
	estilo_act = "feriado";
	
}


if ((5-estiloFeriado_ant)>0) {
	estilo_ant = "feriado";
}

var gamadiv = "";
if (gama) {
	gamadiv = "4ta Gama";
}

var seccional ="-";
if (valor.seccional[0]!=undefined) {
	seccional=valor.seccional[0].name;
}

					lista.push({
						"id_consumos": idOperacion,
						"razonsocial": valor.empresa_madre,
						"id": idOperacion,
						"centroapropiacion_id": valor.catering_id,
						"codigo_costos": valor.codigo_costos,
						"name": valor.name,
						"facturable":  valor.facturable,
						"tipo_empresa": emp_tipo,
						"zonal": zonal,
						"regional": regional,
						"almuerzo": almuerzo_a,
						"cena": cena_a,
						"vianda": vianda_a,
						"desayuno": desayuno_a,
						"merienda": merienda_a,
						"acv": acv,
						"acvb": acvb,
						"ayer": acvc,
						"chart":chart,
						"personal": personal,
						"manoobra":status,
						"observacion":observacion,
						"auditada":auditadas,
						"auditada_fecha":auditadas_fecha,
						"feriados_act":estilo_act,
						"feriados_ant":estilo_ant,
						"gama":gamadiv,
						"seccional":seccional
	                });


					if (status=="Irregular") {
							
						if (auditadas=="INJUSTIFICADA") {
							irregulares.push({
								"id_consumos": idOperacion,
								"razonsocial": valor.empresa_madre,
								"id": idOperacion,
								"centroapropiacion_id": valor.catering_id,
								"codigo_costos": valor.codigo_costos,
								"name": valor.name,
								"tipo_empresa": valor.tipo_empresa,
								"zonal": zonal,
								"regional": regional,
								"almuerzo": almuerzo_a,
								"cena": cena_a,
								"vianda": vianda_a,
								"desayuno": desayuno_a,
								"merienda": merienda_a,
								"acv": acv,
								"acvb": acvb,
								"ayer": acvc,
								"chart":chart,
								"personal": personal,
								"manoobra":status,
								"observacion":comentario,
								"auditada":auditadas,
								"gama":gamadiv,
								"seccional":seccional

			                });
							}

							if (auditadas=="JUSTIFICADA") {
							justificadas.push({
								"id_consumos": idOperacion,
								"razonsocial": valor.empresa_madre,
								"id": idOperacion,
								"centroapropiacion_id": valor.catering_id,
								"codigo_costos": valor.codigo_costos,
								"name": valor.name,
								"tipo_empresa": valor.tipo_empresa,
								"zonal": zonal,
								"regional": regional,
								"almuerzo": almuerzo_a,
								"cena": cena_a,
								"vianda": vianda_a,
								"desayuno": desayuno_a,
								"merienda": merienda_a,
								"acv": acv,
								"acvb": acvb,
								"ayer": acvc,
								"chart":chart,
								"personal": personal,
								"manoobra":status,
								"observacion":comentario,
								"auditada":auditadas,
								"gama":gamadiv,
								"seccional":seccional

			                });
							}
					}



                }


            });


/*

<td id="clientes_ame">0</td>
<td id="salida_ame">0</td>
<td id="catering_ame">0</td>
<td id="sap_ame">0</td>
<td id="granel_ame">0</td>

*/

var clientes_ame = 0;
var salida_ame = 0;
var catering_ame = 0;
var sap_ame = 0;
var granel_ame = 0;


var clientes_cat = 0;
var salida_cat = 0;
var catering_cat = 0;
var sap_cat = 0;
var granel_cat = 0;

$.each(lista,function(clave,valor){



if (valor.razonsocial=="Food Service America") {

	console.log(valor.facturable)
		
if (valor.facturable=="S") {

		clientes_ame++

		if (valor.tipo_empresa=="COMEDOR") {
		
			salida_ame=salida_ame+valor.acv;

		}

		if (valor.tipo_empresa=="CATERING") {
		
			catering_ame=catering_ame+valor.acv;

		}

		if (valor.tipo_empresa=="SAP") {
		
			sap_ame=sap_ame+valor.acv;

		}

		if (valor.tipo_empresa=="GRANEL") {
		
			granel_ame=granel_ame+valor.acv;

		}

}


}



if (valor.razonsocial=="Food Service Catering") {

	if (valor.facturable=="S") {
		clientes_cat++

		if (valor.tipo_empresa=="COMEDOR") {
		
			salida_cat=salida_cat+valor.acv;

		}

		if (valor.tipo_empresa=="CATERING") {
		
			catering_cat=catering_cat+valor.acv;

		}

		if (valor.tipo_empresa=="SAP") {
		
			sap_cat=sap_cat+valor.acv;

		}

		if (valor.tipo_empresa=="GRANEL") {
		
			granel_cat=granel_cat+valor.acv;

		}
	}
}





});


$("#clientes_ame").html(clientes_ame)
$("#salida_ame").html(salida_ame)
$("#catering_ame").html(catering_ame)
$("#sap_ame").html(sap_ame)
$("#granel_ame").html(granel_ame)

var total_ame=clientes_ame+salida_ame+catering_ame+sap_ame+granel_ame;
$("#total_ame").html(total_ame)



$("#clientes_cat").html(clientes_cat)
$("#salida_cat").html(salida_cat)
$("#catering_cat").html(catering_cat)
$("#sap_cat").html(sap_cat)
$("#granel_cat").html(granel_cat)

var total_cat=clientes_cat+salida_cat+catering_cat+sap_cat+granel_cat;
$("#total_cat").html(total_cat)

			
            this.operaciones = lista;




            
             localStorage.removeItem("go");
             $("#actualizar").click(function(){

	             		


									localStorage.setItem("go","Empresas")
									router.go({ name: 'Dashboard' })

            })

            $("#cerrar_estados").click(function(){





            	$("#contenido_irregulares").html("");
            	$("#contenido_irregulares").append('<tr style="background-color: #6a1a1a;color:#fff;font-weight: bold;"><td colspan="6">TOTAL DE OPERACIONES IRREGULARES INJUSTIFICADAS: '+irregulares.length+'</td></tr>');
            	$("#contenido_irregulares").append('<tr style="background-color: #6a1a1a;color:#fff;font-weight: bold;"><td>OPERACIÓN</td><td>TIPO</td><td>ACV/5</td><td>PERSONAL</td><td>STATUS</td><td>OBSERVACIÓN</td></tr>');
            	console.log("IRREGULARES")
            	
            	$("#irregulares_modalLabel").html("Operaciones IRREGULARES: "+hoy_dato)

            	

            	$.each(irregulares,function(clave,valor){
            		console.log(valor.name)
            		$("#contenido_irregulares").append("<tr><td align='left'>"+valor.name+"</td><td align='left'>"+valor.tipo_empresa+"</td><td align='left'>"+valor.acv+"</td><td align='left'>"+valor.personal+"</td><td align='left'>"+valor.manoobra+"</td><td align='left'>"+valor.observacion+"</td></tr>")
            	})






            	$("#contenido_injustificadas").html("");
            	$("#contenido_injustificadas").append('<tr style="background-color: #0f540d;color:#fff;font-weight: bold;"><td colspan="6">TOTAL DE OPERACIONES IRREGULARES JUSTIFICADAS: '+justificadas.length+'</td></tr>');
            	$("#contenido_injustificadas").append('<tr style="background-color: #0f540d;color:#fff;font-weight: bold;"><td>OPERACIÓN</td><td>TIPO</td><td>ACV/5</td><td>PERSONAL</td><td>STATUS</td><td>OBSERVACIÓN</td></tr>');
            	console.log("JUSTIFICADAS")
            	
            	$("#irregulares_modalLabel").html("Operaciones IRREGULARES: "+hoy_dato)

            	

            	$.each(justificadas,function(clave,valor){
            		console.log(valor.name)
            		$("#contenido_injustificadas").append("<tr><td align='left'>"+valor.name+"</td><td align='left'>"+valor.tipo_empresa+"</td><td align='left'>"+valor.acv+"</td><td align='left'>"+valor.personal+"</td><td align='left'>"+valor.manoobra+"</td><td align='left'>"+valor.observacion+"</td></tr>")
            	})

            	
            	


            })

let obj3 = Object.assign(justificadas, irregulares);


             $("#guardar_estados").click(function(){
            	Swal.showLoading()
            	firebase
			        .database()
			        .ref("operaciones_irregulares/"+hoy_dato)
			        .push(obj3,(error) => {
			            
					            if (error) {
					              alert(
					                "error: no se pudo asignar el empleado en la operacion /n verificá la conexión a internet o reintentalo"
					              );
					            } else {
					              console.log("DATOS GUARDADOS EXITOSAMENTE");

					              
					              
					            }
			          }
			        ).then((snap) => {
					     const key = snap.key 
					     var encodedData = window.btoa(hoy_dato+"/"+snap.key);
					     console.log(encodedData)

							     axios
		                          .post(
		                            " https://consumos.foodservice.com.ar/api/enviomail",
		                            {
		                              from: "no-reply@foodservice.com.ar",
		                              to: "amiranda@foodservice.com.ar",
		                              subject: "TIENES OPERACIONES IRREGULARES QUE APROBAR!",
		                              body: "<br><center><div style='background-color:#f9fafb;width:800px;padding:30px;'><table  width='700px' align='center' cellspacing='10'><td>Ingresa a Genesis con tus datos de acceso. Verifica y desaprueba las operaciónes irregulares que consideres para ser enviadas a los regionales y responsables para corregir la situación.<br><br> <a href='https://genesis.foodservice.com.ar'>https://genesis.foodservice.com.ar</a> <br> <br> Recuerda acceder con tu clave segura.</td></table></div></center>",
		                            }
		                          )
		                          .then((response) => {
		                           				 Swal.close();
                                    Swal.fire(
                                      "Datos guardados y enviados correctamente!",
                                      "Si el responsable no encuentra en su bandeja de entrada informa que verifique en su casilla de spam",
                                      "success"
                                    );
		                            })

		                           

            })
			         })


		})).then(() => {
			this.loading = false;
			this.$nextTick(()=>{
				console.log("hola mundo")


				
				$('#empresas').DataTable({
					"columnDefs": [
    { "width": "200px", "targets": 0 }
  ],
					"language": {
						"decimal": ",",
						"thousands": ".",
						"info": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
						"infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
						"infoPostFix": "",
						"infoFiltered": "(filtrado de un total de _MAX_ registros)",
						"loadingRecords": "Cargando...",
						"lengthMenu": "Mostrar _MENU_ registros",
						"paginate": {
							"first": "Primero",
							"last": "Último",
							"next": "Siguiente",
							"previous": "Anterior"
						},
						"processing": "Procesando...",
						"search": "Buscar:",
						"searchPlaceholder": "Término de búsqueda",
						"zeroRecords": "No se encontraron resultados",
						"emptyTable": "Ningún dato disponible en esta tabla",
						"aria": {
							"sortAscending":  ": Activar para ordenar la columna de manera ascendente",
							"sortDescending": ": Activar para ordenar la columna de manera descendente"
						},
					},

					"scrollX": true, 
					"search": {regex:true},
					dom: 'Bfrtip',
					responsive: true,
					nowrap: false,
					buttons: [
						'copy',
						 {
        extend: 'excel',
        text: 'Exportar a Excel',
        customizeData: function (data) {
          // Recorrer los datos
          for (var i = 0; i < data.body.length; i++) {
            var row = data.body[i];
            for (var j = 0; j < row.length; j++) {
              var cellData = row[j];
              // Verificar si el valor contiene una coma
              if (typeof cellData === 'string' && cellData.includes(',')) {
                // Reemplazar la coma por el punto o cualquier otro separador deseado
                row[j] = cellData.replace(',', '.');
              }
            }
          }
        }
      },
						'csv',
						'pdf'
					]
				})
			})
		});

		},
		refrescarEmpresas(seReasigno){
            this.modalAdministrar = false;
            this.modalObservar = false;
			this.modalZonal = false;
			this.modalRegional = false;
            if (seReasigno) {
                $('#empresas').dataTable().fnDestroy();
                this.obtenerInformacionEmpresas();
            }
        },
    },
	async mounted() {
		this.obtenerInformacionEmpresas();		
    },
}

</script>

<style scoped>
.observacion-existente {
	background: #10b759;
	border-radius: 50%;
	padding: 3px 4px;
	padding-top: 4px;
	width: 16px;
	height: 16px;
	position: absolute;
	transform: translate(52px, -20px);
	font-size: 12px;
}

.modal-lg, .modal-xl {
    max-width: 90%;
}

.feriado{
	background-color: #f1e7e78f;
}


#resumen td{
	padding: 10px;
}

</style>